import React, { ReactNode } from 'react';
import LAppFullscreenBackground from '../../layouts/LAppFullscreenBackground';
import { Box, Button, Container, Divider, Grid, Paper, Typography } from '@mui/material';
import { ArrowBackIos } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { AppLogoTextWhite } from '../logo/AppLogo';
import appErrorProbeLang from './probe/langs/appErrorProbeLang';
import { useTranslation } from 'react-i18next';

type FAppErrorProps = {
	variant: 'fullscreen' | 'container';
	content: string | ReactNode;
	title?: string;
	isBackButtonDisplay?: boolean;
};
const FAppError = (props: FAppErrorProps) => {
	const { variant, title, content, isBackButtonDisplay } = props;
	const navigate = useNavigate();
	const { t } = useTranslation();

	return (
		<>
			{variant === 'fullscreen' ? (
				<LAppFullscreenBackground>
					<div style={{ width: '100%', textAlign: 'left', padding: '30px' }}>
						<AppLogoTextWhite style={{ height: '60px' }} />
					</div>
					<Container>
						<div style={{ height: 'calc(100vh - 110px)', display: 'flex' }}>
							<Grid container justifyContent="center" alignItems="center">
								<Grid item sm={6}>
									<Paper variant="outlined" sx={{ padding: '20px', textAlign: 'center' }}>
										<Typography variant="h1" component="h1">
											{title}
										</Typography>
										<Box sx={{ margin: '20px 0px' }}>{content}</Box>
										{isBackButtonDisplay ? (
											<>
												<Divider sx={{ margin: '20px 0px' }} />
												<Box>
													<Button
														size="small"
														startIcon={<ArrowBackIos />}
														variant="contained"
														color="secondary"
														onClick={() => navigate('/')}
													>
														{t(appErrorProbeLang.backToMainPage.tag)}
													</Button>
												</Box>
											</>
										) : (
											''
										)}
									</Paper>
								</Grid>
							</Grid>
						</div>
					</Container>
				</LAppFullscreenBackground>
			) : (
				<>
					<Container>
						<div style={{ height: 'calc(100vh - 110px)', display: 'flex' }}>
							<Grid container justifyContent="center" alignItems="center">
								<Grid item sm={6}>
									<Paper variant="outlined" sx={{ padding: '20px', textAlign: 'center' }}>
										<Typography variant="h1" component="h1">
											{title}
										</Typography>
										<Box sx={{ margin: '20px 0px' }}>{content}</Box>
										{isBackButtonDisplay ? (
											<>
												<Divider sx={{ margin: '20px 0px' }} />
												<Box>
													<Button
														size="small"
														startIcon={<ArrowBackIos />}
														variant="contained"
														color="secondary"
														onClick={() => navigate('/')}
													>
														{t(appErrorProbeLang.backToMainPage.tag)}
													</Button>
												</Box>
											</>
										) : (
											''
										)}
									</Paper>
								</Grid>
							</Grid>
						</div>
					</Container>
				</>
			)}
		</>
	);
};

FAppError.defaultProps = {
	variant: 'fullscreen',
	title: "Sorry but this page doesn't exist",
	isBackButtonDisplay: true,
};

export default FAppError;
